import { BluetoothLowEnergyService } from '@services/bluetooth/BluetoothLowEnergyService'
import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'

// Public functions

/**
 * Cross frame listener for bluetooth low energy communication devices.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'print', etc...
 *          parameters: {object} - object containing the parameters for the BLE call
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function bluetoothLowEnergyServiceListener (message: any) {
    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters

    switch (action) {

    case 'connectBle':
    /**
     * Connects to the bluetooth low energy device.
     */
        return BluetoothLowEnergyService.connectBle(params)
    case 'disconnectBle':
    /**
     * Disconnects from the bluetooth low energy device.
     */
        return BluetoothLowEnergyService.disconnectBle(params)
    case 'readCharacteristicBle':
    /**
     * Reads the characteristic value from the connected bluetooth low energy device.
     */
        return BluetoothLowEnergyService.readCharacteristicBle(params)
    case 'writeCharacteristicBle':
    /**
     * Writes the characteristic value data to the bluetooth low energy device.
     */
        return BluetoothLowEnergyService.writeCharacteristicBle(params)
    }

    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)
}
